// Querys and Mutations
import {
    GET_WITH_PAGINATION,
    ALL_ACTIVE,
    CHANGE_STATUS,
    SAVE,
    UPDATE,
    DELETE
} from '@/graphql/config/RatesLunch'

// models
import { Paginator, ResponseDefault } from '@/models'
import { RateLunch, RatesLunchWithPagination, FormRateLunch } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class RatesLunchService {
    async save (form: FormRateLunch): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: SAVE,
            variables: {
                input: form
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async update (id: number, form: FormRateLunch): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async changeStatus (id: number, status: boolean) {
        const result = await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                status: status
            }
        })
        if (result.data?.updateLunchRate?.id) {
            return {
                success: true,
                errors: []
            }
        } else {
            return {
                success: false,
                errors: 'Error al ejecuar la operación'
            }
        }
    }

    async delete (id: number) {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: false,
            errors: 'Error al ejecuar la operación'
        }
    }

    async getWithPagination (perPage = 10, page = 1): Promise<RatesLunchWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })

        const pagination: Paginator = result.data.lunchRatesWithPagination.paginatorInfo
        const data: [RateLunch] = result.data.lunchRatesWithPagination.data
        const response: RatesLunchWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    async getAllActivated (): Promise<RateLunch[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.lunchRatesActive
    }
}

export default new RatesLunchService()
